var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

import { statuses, statusesInfo } from './control.constant';

export const mergeItems = (stateItems, newItems) => {
    const resultItems = stateItems.map(item => {
        const index = newItems.findIndex(i => i.deviceId === item.deviceId);
        return _extends({}, item, newItems[index]);
    });

    return resultItems;
};

export const getInfoByStatus = (status, isOldData = false) => {
    if (isOldData) return statusesInfo[statuses.OLD_DATA];
    return statusesInfo[status] || statusesInfo[statuses.DEFAULT];
};

export const controlItemsToRows = items => {
    let rows = [],
        rowIndex = 0;

    for (let index = 0; index < items.length; index++) {
        if (!rows[rowIndex]) {
            rows[rowIndex] = [];
        }

        rows[rowIndex].push(items[index]);
        if ((index + 1) % 3 === 0) {
            rowIndex++;
        }
    }

    return rows;
};

export const isDeviceStatusOn = item => {
    let isNotActive = !item.status || !item.status.Ch || item.status.Ch.value !== statuses.ON;
    return isNotActive;
};

export const isNotActiveDeviceStatus = item => {
    let isNotActive = !item.status || !item.status.Ch || !item.power || item.status.Ch && item.power && item.status.Ch.value !== statuses.ON;
    return isNotActive;
};

export const getControlItemStatus = item => {
    let powerText = isNotActiveDeviceStatus(item) ? '' : ' ' + item.power.value + ' W';
    const statusText = item.status && item.status.text + powerText;

    return statusText;
};

export const getControlChartValueAndLabel = power => {
    if (!power) {
        return {
            value: '',
            label: ''
        };
    }

    let value = power;
    let label = value < 1000 ? 'W' : 'kW';
    value = value < 1000 ? value : value / 1000;

    return {
        value, label
    };
};

/* old data */

export const isTheSamePowerData = (stateModel, power) => {
    let result = stateModel.power && stateModel.power.time === power.time;
    return result;
};

export const isOldData = (stateModel, power) => {
    let result = isTheSamePowerData(stateModel, power) && stateModel.oldData.count >= 30;
    return result;
};

export const getOldDataCount = (stateModel, power) => {
    let result = isTheSamePowerData(stateModel, power) ? stateModel.oldData.count + 1 : 0;
    return result;
};


// WEBPACK FOOTER //
// ./~/pluton-core/lib/services/core/control/control.helper.js